// extracted by mini-css-extract-plugin
export default {"person":"styles_person__ZvTWe","personWrapper":"styles_personWrapper__4lzcj","input":"styles_input__JoUP8"};